import { DELETE_GROUP, EDIT_GROUP } from "shared/api";
import { Confirm, Page, SubmitButton, useDialog, useNavigator } from "shared/react";
import { callAPI, callAPIWithNotice } from "../util/api.js";
import { useGroupContext } from "./GroupContext.js";
import { GroupForm } from "./GroupForm.js";

export function GroupSettingsPage(): React.ReactElement {
	const nav = useNavigator();
	const showDialog = useDialog();
	const group = useGroupContext();
	const { id: gid } = group;
	return (
		<Page title="Settings" path="./settings">
			<header>
				<h1>Group settings</h1>
			</header>
			<GroupForm data={group} onSubmit={data => callAPI(EDIT_GROUP, { gid, ...data })}>
				<SubmitButton>Save group</SubmitButton>
				<button
					type="button"
					className="button button-quiet confirm"
					onClick={() =>
						showDialog(
							<article className="modal">
								<p>
									<strong>Are you sure you wish to delete this group?</strong>
								</p>
								<ul>
									<li>All members will be removed from the group.</li>
									<li>All messages and challenge progress will be permanently deleted.</li>
									<li>There is no way to undo this action.</li>
								</ul>
								<Confirm
									onConfirm={async () => {
										await callAPIWithNotice(DELETE_GROUP, gid);
										nav.redirect("/groups");
									}}
								/>
							</article>,
						)
					}
				>
					Delete group
				</button>
			</GroupForm>
		</Page>
	);
}
